<template>
	<v-app>
		<v-app-bar dense app color="primary" dark clipped-left>
            <v-btn icon v-if="$vuetify.breakpoint.mobile" @click="showMenu = !showMenu">
                <v-icon>fa-bars</v-icon>
            </v-btn>
            <v-toolbar-title>
                <v-img height="48px" contain :src="logoPath" ></v-img>
            </v-toolbar-title>
			<v-spacer />
			<v-toolbar-items>
                <v-btn v-if="relogged && $store.state.main.name" text @click="reLogout">
                    <v-icon left>
                        fa-sign-out-alt
                    </v-icon>
                    <span v-if="$vuetify.breakpoint.mobile">{{ $store.state.main.reloggedName.split(' ')[0] }}</span>
                    <span v-else>Logget ind som {{ $store.state.main.reloggedName }}</span>
                </v-btn>
                <v-menu v-if="access && $store.state.main.name" open-on-hover offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" text>
                            <v-icon left>
                                fa-user
                            </v-icon>
                            {{ $store.state.main.name }}
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item link>
                            <v-list-item-content @click="logout">
                                <v-list-item-title>Log ud</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
				<v-btn v-else text to="/login">Login</v-btn>
			</v-toolbar-items>
		</v-app-bar>
        <v-navigation-drawer app clipped :expand-on-hover="!$vuetify.breakpoint.mobile" class="nav-bar" v-model="showMenu">
            <v-list dense nav>
                    <template v-for="item in availableNavItems">
                        <v-list-item
                            v-if="!item.children"
                            :key="item.link"
                            link
                            :to="item.link"
                        >
                            <v-list-item-icon>
                                <v-icon>{{ item.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>
                                {{ item.text }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-group
                            v-else
                            :key="item.link"
                            :prepend-icon="item.icon"
                            no-action
                        >
                            <template v-slot:activator>
                                <v-list-item-title>{{ item.text }}</v-list-item-title>
                            </template>
                            <template
                                v-for="child in filterChildren(item.children)"
                            >
                                <v-list-item
                                    v-if="!child.children"
                                    :key="child.link"
                                    link
                                    :to="child.link"
                                >
                                    <v-list-item-title>{{ child.text }}</v-list-item-title>
                                    <v-list-item-icon>
                                        <v-icon small>{{ child.icon }}</v-icon>
                                    </v-list-item-icon>
                                </v-list-item>
                                <v-list-group
                                    v-else
                                    :key="child.link"
                                    no-action
                                    sub-group
                                >
                                    <template v-slot:activator>
                                        <v-list-item-title>{{ child.text }}</v-list-item-title>
                                    </template>
                                    <v-list-item
                                        v-for="grandChild in child.children"
                                        :key="grandChild.link"
                                        link
                                        :to="grandChild.link"
                                    >
                                        <v-list-item-title>{{ grandChild.text }}</v-list-item-title>
                                        <v-list-item-icon>
                                            <v-icon small>{{ grandChild.icon }}</v-icon>
                                        </v-list-item-icon>
                                    </v-list-item>
                                </v-list-group>
                            </template>
                        </v-list-group>
                    </template>
            </v-list>
        </v-navigation-drawer>
		<v-main>
			<v-container>
				<router-view />
			</v-container>
		</v-main>
	</v-app>
</template>

<script>

export default {
	name: "App",

	components: {},
	data() {
		return {
            showMenu: null,
            navItems: [
                {
                    text: 'Status',
                    icon: 'fa-list',
                    link: '/stats/agents',
                    access: ['admin', 'all']
                },
                {
                    text: 'Overblik',
                    icon: 'fa-eye',
                    link: '/overview',
                    access: ['admin', 'all']
                },
                {
                    text: 'Live',
                    icon: 'fa-microphone',
                    link: '/live',
                    access: ['admin', 'all']
                },
                {
                    text: 'Udvikling',
                    icon: 'fa-chart-line',
                    link: '/development/sales',
                    access: ['admin', 'all']
                },
                {
                    text: 'Rapporter',
                    icon: 'fa-paste',
                    link: '/reports',
                    access: ['admin', 'all']
                },
                {
                    text: 'Emnebehandling',
                    icon: 'fa-project-diagram',
                    link: '/processing',
                    access: ['admin', 'all'],
                    children: [
                        {
                            text: 'Fælles genopkald',
                            icon: 'fa-users',
                            link: '/processing/common-redials',
                            access: ['admin', 'all']
                        },
                        {
                            text: 'Private genopkald',
                            icon: 'fa-user',
                            link: '/processing/private-redials',
                            access: ['admin', 'all']
                        }
                    ]
                },
                {
                    text: 'Kvalitet',
                    icon: 'fa-user-check',
                    access: ['admin', 'all'],
                    children: [
                        {
                            text: 'Registrering',
                            icon: 'fa-cash-register',
                            link: '/quality/status/registration',
                            access: ['admin', 'all']
                        },
                        {
                            text: 'Afvigelser',
                            icon: 'fa-people-arrows',
                            link: '/quality/status/deviations',
                            access: ['admin', 'all']
                        },
                        {
                            text: 'Annullering',
                            icon: 'fa-phone-slash',
                            access: ['admin', 'all'],
                            children: [
                                {
                                    text: 'Status',
                                    icon: 'fa-list',
                                    link: '/quality/status/cancelations',
                                    access: ['admin', 'all']
                                },
                                {
                                    text: 'Udvikling',
                                    icon: 'fa-chart-line',
                                    link: '/quality/development/cancelations',
                                    access: ['admin', 'all']
                                }
                            ]
                        },
                        {
                            text: 'Indbakker',
                            icon: 'fa-inbox',
                            link: '/quality/development/inboxes',
                            access: ['admin', 'all'],
                            children: [  
                                {
                                    text: 'Status',
                                    icon: 'fa-list',
                                    link: '/quality/status/inboxes',
                                    access: ['admin', 'all']
                                },
                                {
                                    text: 'Udvikling',
                                    icon: 'fa-chart-line',
                                    link: '/quality/development/inboxes',
                                    access: ['admin', 'all']
                                }                                                           
                            ]
                        },
                        {
                            text: 'Sager',
                            icon: 'fa-life-ring',
                            access: ['admin', 'all'],
                            children: [  
                                {
                                    text: 'Status',
                                    icon: 'fa-list',
                                    link: '/quality/status/complaints',
                                    access: ['admin', 'all']
                                },
                                {
                                    text: 'Udvikling',
                                    icon: 'fa-chart-line',
                                    link: '/quality/development/complaints',
                                    access: ['admin', 'all']
                                }                                         
                            ]
                        }
                    ]
                },
                // {
                //     text: 'Agenturer',
                //     icon: 'fa-users',
                //     link: '/agents',
                //     access: ['admin', 'all']
                // },
                // {
                //     text: 'Medlyt',
                //     icon: 'fa-headset',
                //     link: '/callLogs',
                //     access: ['admin', 'all']
                // },
                {
                    text: 'Møder',
                    icon: 'fa-handshake',
                    children: [
                        {
                            text: 'Registrering',
                            icon: 'fa-cash-register',
                            link: '/booking/registration/currentMeetings',
                            access: ['admin', 'all', 'tele']
                        },
                        {
                            text: 'Status',
                            icon: 'fa-table',
                            link: '/booking/stats/summary',
                            access: ['admin', 'all', 'booking']
                        },
                        {
                            text: 'Pivot',
                            icon: 'fa-list',
                            link: '/booking/pivot',
                            access: ['admin', 'all']
                        }
                    ],
                    access: ['admin', 'all']
                },
                {
                    text: 'Dashboard',
                    icon: 'fa-th-large',
                    link: '/dashboard',
                    access: ['tele']
                },
                {
                    text: 'Statistik',
                    icon: 'fa-list-ol',
                    link: '/user/stats',
                    access: ['tele']
                },
                // {
                //     text: 'Medlyt',
                //     icon: 'fa-headset',
                //     link: '/user/calllogs',
                //     access: ['tele']
                // },
                {
                    text: 'Fordeling',
                    icon: 'fa-sort-amount-up',
                    children: [
                        {
                            text: 'Agenturer',
                            icon: 'fa-users',
                            link: '/distribution/agents',
                            access: ['admin', 'all', 'tele']
                        },
                        {
                            text: 'Kampagner',
                            icon: 'fa-bullseye',
                            link: '/distribution/campaigns',
                            access: ['admin', 'all', 'tele']
                        }
                    ]
                },
                {
                    text: 'Næstved',
                    icon: 'fa-city',
                    link: '/naestved',
                    access: ['admin', 'all', 'naestved']
                },
                {
                    text: 'Forsikringshjælp',
                    icon: 'fa-city',
                    link: '/fh',
                    access: ['admin', 'all', 'fh']
                },
                {
                    text: 'PiiMedia',
                    icon: 'fa-city',
                    link: '/pii',
                    access: ['admin', 'all', 'pii']
                },
                {
                    text: 'Uddannelse',
                    icon: 'fa-graduation-cap',
                    link: '/user/training',
                    access: ['tele']
                },
                // {
                //     text: 'Nysalgsakademi',
                //     icon: 'fa-school',
                //     link: '/academy',
                //     access: ['tele']
                // },
                {
                    text: 'Kontrolpanel',
                    icon: 'fa-cogs',
                    link: '/controlpanel',
                    children: [
                        {
                            text: 'Uddannelse',
                            icon: 'fa-graduation-cap',
                            link: '/controlpanel/training',
                            access: ['admin', 'all'],
                        },
                        {
                            text: 'Agenturer',
                            icon: 'fa-users',
                            link: '/controlpanel/agents',
                            access: ['admin'],
                        },
                        {
                            text: 'Kampagner',
                            icon: 'fa-bullseye',
                            link: '/controlpanel/campaigns',
                            access: ['admin'],
                        },
                        {
                            text: 'Rapporter',
                            icon: 'fa-paste',
                            link: '/controlpanel/reports',
                            access: ['admin'],
                        },
                        {
                            text: 'Regler',
                            icon: 'fa-scroll',
                            link: '/controlpanel/rules',
                            access: ['admin'],
                        },
                        {
                            text: 'Konti',
                            icon: 'fa-id-card',
                            link: '/controlpanel/accounts',
                            access: ['admin'],
                        },
                        {
                            text: 'Konfiguration',
                            icon: 'fa-sitemap',
                            link: '/controlpanel/configuration',
                            access: ['admin'],
                        },
                        {
                            text: 'FH',
                            icon: 'fa-city',
                            link: '/controlpanel/fh',
                            access: ['admin'],
                        }
                    ]
                }
            ],
            logoPath: require('@/assets/logo.svg')
        };
	},
	computed: {
        availableNavItems () {
            return this.navItems.filter(navItem => {
                // If no children, check for access, otherwise check that at least one child has sufficient access
                return navItem.children
                ? navItem.children.some(link => link.access.includes(this.access))
                : navItem.access.includes(this.access)
            })
        },
		access() {
			return this.$store.getters["main/getAccess"];
        },
        relogged() {
            return this.$store.state.main.relogged
        }
	},
	methods: {
		logout() {
			this.$store.dispatch("main/logout");
			this.$router.push("/login");
        },
        reLogout() {
            this.$store.dispatch('main/reLogout')
			this.$router.push("/overview");
        },
		pathIsActive(path) {
			return this.$route.path.indexOf(path) >= 0;
        },
        filterChildren(children) {
            return children.filter(child => child.access.includes(this.access))
        }
	},
	async created() {
		if (localStorage.getItem("token")) {
			this.$store.commit("main/setToken", localStorage.getItem("token"))
			this.$store.commit("main/setAccess", localStorage.getItem("access"))
			this.$store.commit("main/setOrgCode", localStorage.getItem("orgCode"))
			this.$store.commit("main/setUniqueId", localStorage.getItem("uniqueId"))
			this.$store.commit("main/setDepartment", localStorage.getItem("department"))
			this.$store.commit("main/setName", localStorage.getItem("name"))
		}
        if (localStorage.getItem('relogged')) {
            this.$store.commit("main/setRelogged", true)
            this.$store.commit("main/setReloggedName", localStorage.getItem("reloggedName"))
        }
        if (this.access) this.$store.dispatch("main/getConfig")
	}
};
</script>

<style lang="scss">
.v-tabs {
    flex: 0 1 auto !important;
    width: auto !important;
}
.collapsed-inputs {
    .v-input__slot {
        margin-bottom: 0 !important;
    }
    .v-input--selection-controls {
            margin-top: 0 !important;
            padding-top: 0 !important;
        }
        .v-messages {
            display: none;
        }
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;

        .v-text-field__details {
            display: none !important;
        }
    }
}
.nav-bar {
    .v-list-item__icon {
        display: flex;
        justify-content: center;
        width: 30px;
    }
}
.striped-list {
    .v-list-item:nth-child(odd) {
        background: #f4f4f4;
    }
}
.striped-scroll {
    .v-virtual-scroll__item:nth-child(odd) {
        background: #f4f4f4;
    }
}
.course-list {
    .v-expansion-panel-header {
        border: 1px solid rgba(0, 0, 0, 0.12);
    }
    .v-expansion-panel:not(:last-of-type) .v-expansion-panel-header {
        border-bottom: none;
    }
    .v-expansion-panel--active .v-expansion-panel-header {
        border-bottom: none;
    }
    .v-expansion-panel--next-active .v-expansion-panel-header {
        border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
    }
    .v-expansion-panel-content {
        border: 1px solid rgba(0, 0, 0, 0.12);
    }
}
</style>